

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Ahmed Raza",
  title: "Hi all, I'm Ahmed",
  subTitle: emoji(
    "Associate Software Engineer | Fullstack | MERN"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1jgpYquPcGZQJWJvvtvbQqXRxAeWcxs4W/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ahmadrazach",
  linkedin: "https://www.linkedin.com/in/ahmadraza/",
  gmail: "ahmadrazach26@gmail.com",
  // gitlab: "https://gitlab.com/",
  //facebook: "https://www.facebook.com/ahmadraza226/",
  medium: "https://medium.com/@ahmadrazach26",
  //stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/davidrakosi/',
  twitter: 'https://twitter.com/AhmedRa93015817',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Want to create solutions with the website development",
  skills: [
    
    emoji(
      "⚡ Building progressive business and personal Web Applications ( PWA )"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ SQL / NoSQL"
    ),
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "FAST NUCES",
      logo: require("./assets/images/unilogo.png").default,
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2017 - September 2021",
      desc:"Main Events:",
      descBullets: [
        "Dean's List Fall 2020",
        "Core Team Member of Developer Student Club in 2020-2021.",
        "Built a Hostel Automation System for the university hostel to automate the finance, meal, transport & inventory processes",
        "Managed university events like Daira'18, Welcome'18, and Daira'19 with Event Management Team."
      ],
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "PROGRAMMING : Javscript, Python, C++, C#", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "FRONTEND : Javascript,Bootstrap, ReactJS, Material UI",
      progressPercentage: "90%"
    },
    {
      Stack: "BACKEND : NodeJs, Express, Ionic, .NET",
      progressPercentage: "70%"
    },
    {
      Stack: "DATABASE : SQL ( MySQL ), NoSQL ( Firebase, MonogoDB)",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Development Intern",
      company: "WADDCO",
      companylogo: require("./assets/images/WADDCOs.png").default,
      date: "AUG 2019 – OCT 2020",
        descBullets:[
          "Supporting the team in the development of software based on agreed projects and platforms.",
          "Learn and follow coding standards and ensure compliance with quality measures.",
          "Ensuring code is tested in accordance with the guidelines provided by the team manager.",
          "Shadowing senior developers to learn the industry best practices",
        ]
    },
    
    
    {
      role: "Junior Web Developer",
      company: "WADDCO",
      companylogo: require("./assets/images/WADDCOs.png").default,
      date: "JUN 2021 – Present",
      descBullets:[
        "Designed, wrote, and developed multiple Front-end UI components with complete accuracy, for an eCommerce platform with 20K+ active users using React JS, HTML5, CSS3, and Bootstrap, in an agile team.",
       "Designed, built, and maintained robust back-end REST APIs using Node and ES6 framework, which reduced the time to ship new features by 5%.",
       "Coordinated with the engineers for testing and performance checks by reviewing code, debugging problems, and correcting issues."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "ahmadrazach", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Latest Projects",
  subtitle: "SOME OF MY LATEST PROJECTS USING MERN, BOOTSTRAP, FIREBASE",
  projects: [
    {
      image: require("./assets/images/proshop.png").default,
      projectName: "ProShop",
      projectDesc: "Custom eCommerce store with MERN",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://proshopahmed.herokuapp.com/"
        },
        {
          name: "Source code",
          url: "https://github.com/ahmadrazach/ProShop.git"
        },
      ]
    } ,
    {
      image: require("./assets/images/linkedin.png").default,
      projectName: "LinkedIn Clone",
      projectDesc: "LinkedIn style frontend and Feed",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://linkedin-clone-ea448.web.app/"
        },
        {
          name: "Source code",
          url: "https://github.com/ahmadrazach/linkedin-clone.git"
        },
      ]
    } ,
    {
      image: require("./assets/images/HPAS.png").default,
      projectName: "H-PAS",
      projectDesc: "Hostel Process Automation System",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://hostel-process-automation-frontend.netlify.app/w_home.html"
        },
        {
          name: "Source code",
          url: "https://github.com/ahmadrazach/Hostel-Process-Automation-System-frontend.git"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/moviesearcher.png").default,
      projectName: "MovieSearcher",
      projectDesc: "Sarch and View movies info",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://moviesearcherahmed.vercel.app/"
        },
        {
          name: "Source code",
          url: "https://github.com/ahmadrazach/Javascript-Challanges/tree/main/movie-app"
        },
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Javascript Algorithms & Datastructures",
      subtitle:
        "Completed a Free Code Camp 300+ hours practical course",
      image: require("./assets/images/designcourse.jpg").default,
      footerLink: [
        {
          name: "Certification",
          url:
            "https://www.freecodecamp.org/certification/ahmed-raza-226/javascript-algorithms-and-data-structures"
        }
      ]
    },
    {
      title: "Problem Solving Certificate",
      subtitle:
        "Certificate Problem Solving and Gold Badge after completing 60+ problem solving questions",
      image: require("./assets/images/hackerrank.jpg").default,
      footerLink: [
        {
          name: "Certification",
          url:
            "https://www.hackerrank.com/certificates/1e656edc4afc"
        },
        {
          name: "Gold Level Badge",
          url:
            "https://www.hackerrank.com/certificates/1e656edc4afc"
        }
      ]
    },

    {
      title: "Web Development Internship",
      subtitle: "Certificate of completion of internship in Web Development from WADDCO of 3 months",
      image: require("./assets/images/internship.png").default,
      footerLink: [
        {
          name: "Intership Letter",
          url: "https://drive.google.com/file/d/1wVd_aKK45jiENP5hb91VpO35SQgrbgs9/view?usp=sharing"
        }
      ]
    },
    {
      title: "Google Hashcode 2020",
      subtitle:
        "Participated in Google Hashcode 2020 and came 7th in the Pakistan",
      image: require("./assets/images/hashcode.png").default,
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1w1FQobny7kwvx3x80EZmrfZpHbFH9cPn/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "I love to make notes of what I leanrt and publish with others",

  blogs: [
    {
      url:
        "https://medium.com/dev-genius/code-splitting-in-react-js-c68dcb4e153b",
      title: "Improving React application performance using code splitting",
      description:
        "As we know that  If you don’t optimize the code, it will affect the performance of your application badly. But how exactly to optimize ? Lets find !"
    },
    {
      url:
        "https://substantial-breath-281.notion.site/Resources-Database-9e4bbea6b1de445bae6bdd60b95909e1",
      title: "Resources for Web Developers",
      description:
        "Some free resources that I used in my web development projects. Let's see if you find anything useful!"
    },
    {
      url:
        "https://substantial-breath-281.notion.site/FreeCode-Camp-Javascript-Algorithms-DataStructures-badfecfe2dbf4d4cb6855e06a2f52289",
      title: "Modern Javascript Algorithms & Datastructures",
      description:
        "All useful topics related to modern javascript development like ES6, functional programming, regular expressions etc."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "Some talks which I can found in my digital memory",

  talks: [
    {
      title: "Give me my identity back !",
      subtitle: "Invited Mr. M. Ehtisham to talk about crafting a secure digital future",
      slides_url: "https://www.linkedin.com/posts/ahmedrazach_innovation-learning-research-activity-6818278660915777536-azo_?utm_source=linkedin_share&utm_medium=member_desktop_web",
      event_url: "https://youtu.be/HKJqnQBMRDk"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
      "https://youtu.be/HKJqnQBMRDk",
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "You can connect me with the following ways",
  number: "(311) 471 7226",
  email_address: "ahmadrazach26@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "AhmedRa93015817", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
